import { makeCollectionQuery } from "@web-monorepo/fetchers";
import { useMemo } from "react";

export const useStudentsFetcher = makeCollectionQuery({
  fetcherName: "toolkitStudents",
  path: "/api/dojoClass/{classId}/student",
});

const ATTENDING_STATUSES = new Set(["present", "tardy"]);

export function useAttendingStudents(classId: string, options?: { enabled?: boolean }) {
  const { data: students, ...rest } = useStudentsFetcher({ classId }, { enabled: options?.enabled });

  const attendingStudents = useMemo(() => {
    if (!students) return null;
    return students.filter((student) => student.currentAttendance && ATTENDING_STATUSES.has(student.currentAttendance));
  }, [students]);

  return { data: attendingStudents, ...rest };
}
